export default __webpack_public_path__ + "static/media/screenshot.e5760ea8.png";